import { render, staticRenderFns } from "./Publish.vue?vue&type=template&id=3695c504&scoped=true&"
import script from "./Publish.vue?vue&type=script&lang=js&"
export * from "./Publish.vue?vue&type=script&lang=js&"
import style0 from "./Publish.vue?vue&type=style&index=0&id=3695c504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695c504",
  null
  
)

export default component.exports